export enum ERROR_TITLES {
  ERROR_WHILE_SAVING_DATA = 'Error while saving data',
}
